import { useEffect } from 'react';
import { useAuthStore } from '../../store/authStore';

interface CrispChatProps {
  websiteId?: string;
}

export const CrispChat: React.FC<CrispChatProps> = ({ 
  websiteId = '8fe0ea0a-18cc-45ea-827b-a042228cdb14' 
}) => {
  const { user } = useAuthStore();

  useEffect(() => {
    // Initialize Crisp chat
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = websiteId;

    // Load the Crisp script
    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = true;
    document.head.appendChild(script);

    // Cleanup function
    return () => {
      // If you need to remove Crisp when component unmounts
      if (window.$crisp) {
        window.$crisp.push(['do', 'chat:hide']);
      }
      document.head.removeChild(script);
    };
  }, [websiteId]);

  // Set user data when user changes
  useEffect(() => {
    if (user && window.$crisp) {
      // Set user email
      window.$crisp.push(['set', 'user:email', user.email || '']);
      
      // Set user nickname if name is available
      const userName = user.email?.split('@')[0] || '';
      if (userName) {
        window.$crisp.push(['set', 'user:nickname', userName]);
      }
      
      // We don't set the avatar since we don't know the property name
      // You can enable this if your user object has an avatar property
      // window.$crisp.push(['set', 'user:avatar', '']);
    }
  }, [user]);

  // This component doesn't render anything visible
  return null;
};

// Add TypeScript declarations for Crisp
declare global {
  interface Window {
    $crisp: any[];
    CRISP_WEBSITE_ID: string;
  }
} 